export const VERSION = '0.74.0'; // x-release-please-version
//# sourceMappingURL=version.mjs.map